import styled from 'styled-components';
import { device } from './Theme';
import { Link } from 'react-scroll';

export const StyledHero = styled.section`
  height: 100vh;
  background: #f5f5f9;
  position: relative;
  /* background-image: radial-gradient(
      circle at 15% 73%,
      rgba(170, 67, 111, 0.4),
      hsla(0, 0%, 100%, 0) 15%
    ),
    radial-gradient(
      circle at 75% 35%,
      rgba(119, 33, 214, 0.4),
      hsla(0, 0%, 100%, 0) 15%
    ); */
  /* 
  background-image: radial-gradient(
      circle at 15% 73%,
      rgba(170, 67, 111, 0.4),
      hsla(0, 0%, 100%, 0) 15%
    ),
    radial-gradient(
      circle at 75% 35%,
      rgba(0, 112, 243, 0.4),
      hsla(0, 0%, 100%, 0) 15%
    ); */

  padding: 0 1.8rem;

  @media ${device.tablet} {
    padding: 0 1.8rem;
  }

  @media ${device.mobile} {
    padding: 0 1.2rem;
  }

  @media screen and (min-height: 780px) {
    height: 780px;
  }
`;

export const HeroContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
`;

export const HeroText = styled.div`
  h1,
  h2 {
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: 4.2rem;
    font-weight: 900;
    line-height: 1;
    color: ${({ theme }) => theme.colors.heading};
  }
  h2 {
    color: #414141;
    margin-top: 0.6rem;
    margin-bottom: 1.4rem;
  }

  p {
    line-height: 1.6;
    font-size: 1.06rem;

    &.greet {
      font-weight: 500;
      color: ${({ theme }) => theme.colors.primary};
      margin-bottom: 1rem;
    }

    &.desc {
      max-width: 30rem;
      margin-bottom: 2rem;
      max-width: 25rem;
    }
  }

  @media ${device.laptop} {
    h1,
    h2 {
      font-size: 3rem;
    }
  }

  @media ${device.tablet} {
    h1,
    h2 {
      margin-top: unset;
      font-size: 4rem;
    }
  }

  @media ${device.mobile} {
    h1,
    h2 {
      font-size: 2.8rem;
      margin-bottom: 0.5rem;
    }
    h2 {
      margin-bottom: 1.2rem;
    }

    p {
      font-size: 1rem;
      margin-bottom: 1.7rem;
    }

    a {
      margin-bottom: 1.5rem;
    }
  }
`;

export const Button = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.75em 1.3em;
  border-radius: ${({ theme }) => theme.borderRadius};
  background: ${({ theme }) => theme.colors.primary};
  color: #fff;
  font-size: 1rem;
  transition: ${({ theme }) => theme.transition};

  &:hover {
    background: ${({ theme }) => theme.colors.hoverPrimary};
  }

  svg {
    font-weight: 900;
    font-size: 1.3em;
  }

  @media ${device.tablet} {
    font-size: 0.95rem;
  }
`;

export const HeroImg = styled.div`
  width: 28rem;
  height: auto;
  margin-top: 2.5rem;

  @media ${device.tablet} {
    display: none;
  }
`;

export const ScrollIndicator = styled.div`
  width: 1.4rem;
  height: 2.6rem;
  border: 1px solid #333;
  border-radius: 30px;
  position: absolute;
  left: 50%;
  bottom: 4%;
  transform: translateX(-50%);

  &::before {
    content: '';
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.primary};
    position: absolute;
    right: 49%;
    transform: translateX(50%);
    animation: scroll 2.5s infinite;
  }

  @keyframes scroll {
    0% {
      bottom: 75%;
      opacity: 1;
    }
    100% {
      bottom: 10%;
      opacity: 0;
    }
  }
`;
